/**
 * All possible icon sizes based on pixels as defined by the icon repo.
 */
// hint for devs: The order of these values is used by the generator script.
// New size options could be added but the order always has to be from small to big.
export const validIconSizes = ['s8', 's12', 's16', 's24', 's32', 's40', 's48', 's64', 's72', 's80'];
export const isIconSize = (value) => validIconSizes.includes(value);
